import React, { useState, useEffect } from "react";
import styles from "./Notification.module.sass";
import List from "./List";
import Filters from "./Filters";
import Panel from "./Panel";
import { getNotifications, deleteMultipleNotifications, markMultipleNotificationsAsRead } from "../../services/notification.service";
import { showSuccess, showError } from "../../services/toast.service";
import eventEmitter from "../../services/event.service";

const filters = [
    "Documents à valider",
    "Contrat Refusé",
    "Contrat Signé",
];

const Notification = () => {
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [selectedNotifications, setSelectedNotifications] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        fetchNotifications();
        
        // S'abonner à l'événement de mise à jour des notifications
        eventEmitter.subscribe('notificationsUpdated', fetchNotifications);
        
        return () => {
            eventEmitter.unsubscribe('notificationsUpdated', fetchNotifications);
        };
    }, []);
    
    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const items = await getNotifications();
            setNotifications(items);
            setSelectedNotifications([]);
        } catch (error) {
            console.error("Failed to fetch notifications:", error);
        } finally {
            setLoading(false);
        }
    };
    
    const handleSelect = (id) => {
        setSelectedNotifications(prev => {
            if (prev.includes(id)) {
                return prev.filter(item => item !== id);
            } else {
                return [...prev, id];
            }
        });
    };
    
    const handleDelete = async () => {
        try {
            await deleteMultipleNotifications(selectedNotifications);
            showSuccess(`${selectedNotifications.length} notification${selectedNotifications.length > 1 ? 's' : ''} supprimée${selectedNotifications.length > 1 ? 's' : ''} avec succès`);
            setNotifications(prev => prev.filter(item => !selectedNotifications.includes(item.id)));
            setSelectedNotifications([]);
        } catch (error) {
            showError(`Erreur lors de la suppression des notifications: ${error.message}`);
        }
    };
    
    const handleMarkAsRead = async () => {
        try {
            // Utiliser markMultipleNotificationsAsRead avec les notifications sélectionnées
            await markMultipleNotificationsAsRead(selectedNotifications);
            showSuccess(`${selectedNotifications.length} notification${selectedNotifications.length > 1 ? 's' : ''} marquée${selectedNotifications.length > 1 ? 's' : ''} comme lue${selectedNotifications.length > 1 ? 's' : ''}`);
            
            // Mettre à jour localement les notifications marquées comme lues
            setNotifications(prev => prev.map(item => 
                selectedNotifications.includes(item.id) ? { ...item, read: true } : item
            ));
            setSelectedNotifications([]);
        } catch (error) {
            showError(`Erreur lors du marquage des notifications: ${error.message}`);
        }
    };

    return (

        <>
        <div className={styles.container}>
            <div className={styles.shop}>
                <div className={styles.background}>
                    <img src="/images/content/bg-shop.jpg" alt="Background" />
                </div>

                <div className={styles.row}>
                    <div className={styles.col}>
                        <List 
                            className={styles.card} 
                            notifications={notifications}
                            loading={loading}
                            selectedNotifications={selectedNotifications}
                            onSelect={handleSelect}
                        />
                    </div>
                 
                 
                </div>
            </div>
            <Panel 
                selectedNotifications={selectedNotifications} 
                onDelete={handleDelete} 
                onMarkAsRead={handleMarkAsRead} 
            />
        </div>
        </>



    );
};

export default Notification;
